//import sayHello from './lib/sayHello';
//sayHello(); 
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { CustomEase } from "gsap/CustomEase";

import lozad from 'lozad';



gsap.registerPlugin(ScrollTrigger, CustomEase, ScrollToPlugin);
gsap.config({ nullTargetWarn: false, });

// screenCheck Jquery
import screencheck from './lib/screenCheck';
//screencheck();



// Banner Slider Jquery
import bannerSlider from './lib/bannerSlider';
bannerSlider();


// Accordion  Jquery
import homeAccordion from './lib/homeAccordion';
homeAccordion();

// Join Mob Slider Jquery
import joinMobileSlider from './lib/joinMobSlider';
joinMobileSlider();

// Main Accordion Jquery
import mainAccordion from './lib/accordion';
mainAccordion();

// Timeline Slider Jquery
import timelineSlider from './lib/timelineSlider';
timelineSlider();

// Partner Logo Jquery
import partnerLogo from './lib/partnerLogo';
partnerLogo();

// Header Navigation Jquery
import headerNav from './lib/headNav';
headerNav();

// circleAnimation Jquery
import circleAnime from './lib/circleAnimation';
circleAnime('.circle-animation');

import fancyBoxModal from './lib/fancyboxmodal';
fancyBoxModal();

import testimonialSlider from './lib/testimonialSlider';
testimonialSlider();

// collaboration Mob Slider Jquery
import collaborationMobileSlider from './lib/collaborationMobSlider';
collaborationMobileSlider();

// About Slider  Jquery
import aboutSlider from './lib/aboutSlider';
aboutSlider();


// client Slider Jquery
import clientSlider from './lib/clientSlider';
clientSlider();

// customPopup  Jquery
// import customPopup from './lib/customPopup';
// customPopup();

; (function ($, window, document, undefined) {



  $(document).ready(function () {

    // Lozad for Video
    gsap.set(".lozad-video", { opacity: 0 });
    if ($('.lozad-video').length) {
      var pictureObserver = lozad('.lozad-video', {
        threshold: 0.5,
        rootMargin: "0px 0px 40% 0px",
        loaded: function (el) {
          // Custom implementation on a loaded element
          el.classList.add('fade');
          gsap.to(el, {
            opacity: 1,
            duration: 1,
            ease: "power1",
            clearProp: true
          })
        }
      })
      pictureObserver.observe();
    }

    //$('.lozad').length
    gsap.set(".lozad", { opacity: 0 });
    // Lozad Image
    if ($('.lozad').length) {
      const observer = lozad('.lozad', {
        threshold: .5,
        rootMargin: "0px 0px 30% 0px",
        enableAutoReload: true, // it will reload the new image when validating attributes changes
        loaded: function (el) {
          // Custom implementation on a loaded element
          el.classList.add('loaded');
          gsap.fromTo(el, {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 1,
            clearProp: true,
            ease: "power1",

          })
          //el.classList.add('fade');
        }
      });
      observer.observe();
    }

    /* Header Sticky
    ---------------------------------------------------------------------*/
    if ($("#header").length) {
      $(window).on('scroll', function () {
        var headerHeight = $('#header').outerHeight() - 50;
        if ($(this).scrollTop() > headerHeight) {
          $("#header").addClass("sticky");
        } else {
          $("#header").removeClass("sticky");
        }
      });
    }

    /* Header Sticky
    ---------------------------------------------------------------------*/
    if ($("#header").length) {
      $(window).scroll(function () {
        var headerHeight = $('#header').outerHeight() - 50;
        if ($(this).scrollTop() > headerHeight) {
          $("#header").addClass("sticky");
        } else {
          $("#header").removeClass("sticky");
        }
      });
    }


    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
      $("html").addClass("mac");
    } else {
      $("html").addClass("pc");
    }

    /* Menu click
      ---------------------------------------------------------------------*/
    $(document).on('click', "#menu", function () {
      $(this).toggleClass('menuopen');
      $('#mainmenu').toggleClass('active');
      $('body').toggleClass('overflowHide');
      $('.is-overlay').toggleClass('active');
      return false;
    });
    $(document).on('click', "#mainmenu .is-overlay, #mainmenu .close", function () {
      $("#menu").removeClass('menuopen');
      $('#mainmenu').removeClass('active');
      $('body').removeClass('overflowHide');
      $('.is-overlay').removeClass('active');
      return false;
    });

    // navigation dropdown
    $('.header-menu li > ul').parent('li').addClass('hasnav');
    $('.header-menu li ul.sub-menu').prev('a').addClass('hasarrow');
    $('.header-menu li ul.sub-menu .sub-menu').parent('li').parent('ul').addClass('hassubnav');

    $(".hasnav > a > i").on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var target = e.target;
      var subItem = $(target).parent('a').next();
      var depth = $(subItem).parents().length;
      var allAtDepth = $(".header-menu li ul.sub-menu").filter(function () {
        if ($(this).parents().length >= depth && this !== subItem.get(0)) {
          return true;
        }
      });
      $(allAtDepth).slideUp('normal');
      $(allAtDepth).prev("a").removeClass('open')
      $(this).parent('a').toggleClass('open');
      subItem.slideToggle('normal');
      return false;
    });


    let tl = gsap.timeline({
      scrollTrigger: {
        //toggleActions: "restart none none reset",
        trigger: ".expertise-boxes",
        start: "top 80%",
        end: "bottom 20%",
        markers: false,
      }
    });
    gsap.set(".expertise-box", { opacity: 0, y: 40 });

    tl.to(".expertise-box", {
      opacity: 1,
      y: 0,
      stagger: 0.15,
      ease: "power3.Out",
      delay: 1
    }, "-=1.2")

    // Team Animation
    const abtMembers = document.querySelectorAll('.people-block');
    abtMembers.forEach((member) => {
      const itemTitle = member.querySelector('h5');
      const itemDesignation = member.querySelector('span');
      gsap.set(itemTitle, { opacity: 0, y: 10 });
      gsap.set(itemDesignation, { opacity: 0, y: 10 });
    })
    gsap.set('.people-block', { opacity: 0, y: 40 });

    const intconfig = {
      threshold: 0.5
    };

    const membertl = gsap.timeline()

    let abtobserver = new IntersectionObserver(function (entries, self) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          let overlap = '-=0.3';

          if (!membertl.isActive()) {
            overlap = '+=0';
          }

          membertl.to(entry.target, {
            autoAlpha: 1,
            y: 0,
            duration: 0.4,
            ease: "power4.Out",
            onComplete: () => {
              gsap.to(entry.target.querySelector("h5"), {
                autoAlpha: 1,
                duration: 0.2,
                y: 0,
              })
              gsap.to(entry.target.querySelector("span"), {
                autoAlpha: 1,
                duration: 0.3,
                y: 0,
                delay: 0.1
              })
            },
          }, overlap);
          self.unobserve(entry.target);
        }
      });
    }, intconfig);

    abtMembers.forEach(box => {
      abtobserver.observe(box);
    });

    $(window).on('resize', function () {
      // const headerheight = $('#header').outerHeight();
      // $('body:not(.home)').css("padding-top", headerheight);

      //About us People for mobile update
      if ($(".all-people-blocks").length) {
        if (screencheck(767)) {
          $(".all-people-blocks .people-block:nth-child(16)").nextAll().addClass("hidden");
        } else {
          $(".all-people-blocks .people-block:nth-child(16)").nextAll().removeClass("hidden");
        }
      }

      //Company Group for mobile update
      if ($(".company-group-logos").length) {
        if (screencheck(767)) {
          $(".company-group-logos .company-logo:nth-child(6)").nextAll().addClass("hidden");
        } else {
          $(".company-group-logos .company-logo:nth-child(6)").nextAll().removeClass("hidden");
        }
      }

    }).resize();

    $('.our-people-sec').find('.load-more a').on('click', function () {
      if (screencheck(767)) {
        const sltop = $(this).offset().top;
        //console.log(sltop);
        window.scrollTo({ top: sltop + 30, behavior: 'smooth' });
        $('.all-people-blocks .people-block').removeClass("hidden");
        $(this).parent('.load-more').hide()
        return false;
      }
    });

    $('.company-group-sec').find('.load-more a').on('click', function () {
      if (screencheck(767)) {
        $(this).parent('.load-more').hide();
        $('.company-group-logos .company-logo').removeClass("hidden");
        return false;
      }
    });

    if ($('body').hasClass("home")) {
      var scPostop = window.pageYOffset || document.documentElement.scrollTop;
      var screenHeight = screen.height;
      //console.log(scPostop, screenHeight);
      if (scPostop > screenHeight) {
        const header = document.querySelector("#header");
        header.style = "transition:none";
        document.querySelector(".header-row").style = "padding: 15px 0; transition:none";
        header.classList.add("sticky");
        setTimeout(() => {
          header.style = "";
          document.querySelector(".header-row").style = "";
        }, 400);
      }

    }

    $('.search-box .search-icon').on('click', function () {
      $('.search-inner-sec').addClass('active');
      $('.is-overlay').addClass('active');
      if ($('#menu').hasClass('menuopen')) {
        $('#menu').removeClass('menuopen');
        $('#mainmenu').slideUp('normal');
        $('#mainmenu').removeClass('active');
        $('body').removeClass('overflowHide');
      }
      return false;
    }
    );

    $('.search-inner-sec .close').on('click', function () {
      $(this).parent('.search-inner-sec').removeClass('active');
      $('.is-overlay').removeClass('active');
      return false;
    }
    );

    $('.is-overlay').on('click', function () {
      $(this).removeClass('active');
      $('.search-inner-sec').removeClass('active');
      $('#mainmenu').removeClass('active');
      $('#menu').removeClass('menuopen');
      $('body').removeClass('overflowHide');
      return false;
    }
    );

    /*Menu Height small class Add/Remove
    ---------------------------------------------------------------------*/
    function navHeightCheck() {
      if ($('.header-row #mainmenu ul').outerHeight() > $(window).height()) {
        $('.header-row #mainmenu').addClass('menu-h');
      } else {
        $('.header-row #mainmenu').removeClass('menu-h');
      }
    }
    navHeightCheck();
    $(window).on('resize', function () {
      navHeightCheck();
    }).resize();

  });



  function close_popup() {
    var $data = $('.modal-backdrop');
    $data.parents('.popouterbox').hide();
    $('body').removeClass('overflowhidden');
    $('.popouterbox .popup-block').removeAttr('style');
    return false;
  }
  $(document).on("click", ".poptrigger", function () {
    close_popup();

    if ($(this).find('.shareit-timeline').is(':visible')) return false;


    const popID = $(this).attr('data-rel');
    $('html').addClass('overflowhidden');
    const winHeight = $(window).height();
    $(`#${popID}`).fadeIn(200, function () {
      setTimeout(function () {
        $(".popouterbox").scrollTop(0);
        $('.popouterbox .popup-content').fadeIn(100);
      }, 10);
    });

    const popheight = $(`#${popID}`).find('.pop-contentbox').outerHeight(true) + 60;

    if ($('.popup-block').length) {
      const popMargTop = popheight / 2;
      if (winHeight > popheight) {
        $(`#${popID}`).find('.popup-block').removeClass('taller');
      } else {
        $(`#${popID}`).find('.popup-block').addClass('taller');
      }

    }

    $(`#${popID}`).append("<div class='modal-backdrop'></div>");
    $('.popouterbox .modal-backdrop').fadeTo("slow", 0.80);
    $(`#${popID}`).focus();
    return false;
  });


  function popHeightCheck() {
    const popheighton = $('.popouterbox .pop-contentbox').height() + 60;
    const winHeight = $(window).height();
    if (popheighton > winHeight) {
      $('.popouterbox .popup-block').removeAttr('style').addClass('taller');

    } else {
      $('.popouterbox .popup-block').removeClass('taller');
    }
  }

  $(window).on("resize", function () {
    if ($('.popouterbox').length && $('.popouterbox').is(':visible')) {
      popHeightCheck();
    }
  }).resize();

  // Close popup
  $(document).on('click', '.popouterbox .close, .modal-backdrop', function () {
    $(this).parents('.popouterbox').fadeOut(300, function () {
      $(this).find('.modal-backdrop').fadeOut(250, function () {
        $('html').removeClass('overflowhidden');
        $('.popouterbox .popup-block').removeAttr('style');
        $('.popouterbox .popup-content').fadeOut(100);
        $(this).remove();
      });
    });
    return false;
  });


  //


  if ($('.expertise-sector-section .sector-video').length > 5) {

    $('.expertise-sector-section .sector-video').each((index, item) => {
      if (index > 4) {
        $(item).addClass('hidden')
      }

    })
    $('.load-more-sectors').addClass('visible')
  }
  $(document).on('click', '.load-more-sectors', function () {
    $('.expertise-sector-section .sector-video').removeClass('hidden');
    $(this).remove()
    return false;
  })


  if ($('.filter-main-sec .work-row .work-box').length) {
    if ($('.filter-main-sec').hasClass("creative")) {
      $('.filter-main-sec .work-row .work-box').each((index, item) => {
        if (index > 8) {
          $(item).addClass('hidden');
          //console.log("greater 9");
          $('.filter-main-sec .load-more').addClass('visible');
        }

      })

    }
    if ($('.filter-main-sec').hasClass("engagement")) {
      $('.filter-main-sec .work-row .work-box').each((index, item) => {
        if (index > 5) {
          $(item).addClass('hidden');
          $('.filter-main-sec .load-more').addClass('visible');
        }

      })

    }
  }
  $(document).on('click', '.filter-main-sec .load-more', function () {
    $('.filter-main-sec .work-row .work-box').removeClass('hidden');
    $(this).remove()
    return false;
  })


  document.querySelectorAll(".scroll-navitem").forEach((link, index) => {
    link.children[0].addEventListener("click", (e) => {
      //var getHash = link.dataset.id;
      // console.log("click link same");
      // console.log(link);
      var href = link.children[0].href;
      var current_url = window.location.href;
      var rootURL = $('#logo').attr('href')
      //console.log(typeof rootURL, "Z&&&", rootURL, "Z&&&", current_url);
      //console.log(current_url);
      current_url = current_url.split('#')[0];
      //console.log(href, "dsadas&&&", current_url);
      if (href.includes(current_url) && current_url != rootURL) {

        // if($(link).hasClass('linktopage')){
        //   window.location.href = href;
        // } 
        //console.log("if");
        e.preventDefault();
        $("nav#mainmenu .close").trigger('click');
        window.scrollTo({ top: 0 });
        var getHash = href.split('#')[1];
        console.log(getHash);
        var getheaderHeight = document.querySelector("#header").clientHeight;
        gsap.to(window, { duration: 1, scrollTo: { y: "#" + getHash, offsetY: getheaderHeight } });

        //console.log("if");
        return false;
      }


      //window.scrollTo({ top: 0});

      //console.log(window.scrollTo(0));


      //console.log(getheaderHeight);
      // $("#header").one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function(event) {
      //   console.log("endd");
      //   var getheaderHeight = document.querySelector("#header").clientHeight;
      //   var getheaderHeight = document.querySelector("#header").clientHeight;
      //   console.log(getheaderHeight);

      //   gsap.to(window, { duration: 1, scrollTo: { y: "#" + getHash, offsetY: getheaderHeight } });
      // });
      //console.log("dsdds", getheaderHeight);

      // setTimeout(function () {
      //   alert("dw")
      // }, 2000);

    });
  });

  if (window.location.hash) {
    let getHash = window.location.hash.split('#')[1];
    //console.log("onload");
    document.querySelector("#header").classList.add = "sticky";
    var getheaderHeight = document.querySelector("#header").clientHeight;
    //var getHash = link.href.split('#')[1];
    //console.log('load', getHash);
    if (getHash.length) {
      window.scrollTo({ top: 100 });
      gsap.to(window, { duration: 1, scrollTo: { y: "#" + getHash, offsetY: getheaderHeight } });
    }
  }

  /* Licensing JS
    ---------------------------------------------------------------------*/
  setTimeout(function () {
    if ($(".cky-consent-container").length) {
      var cookieBarHeight;
      $(window).on('resize', function () {
        cookieBarHeight = $(".licensing").outerHeight();
        console.log(cookieBarHeight)
        if ($('.cky-consent-container').is(":visible")) {
          console.log("visible")
          $(".licensing").css("bottom", + $(".cky-consent-bar").outerHeight());
        } else {
          $(".licensing").css("bottom", "0");
        }
      }).resize();

      $('.cky-btn-accept').click(function () {
        $(".licensing").css("bottom", "0");
        $("#footer").css("padding-bottom", cookieBarHeight + 20)

      });

    }
  }, 500)

  setTimeout(function () {

    $(window).on('resize', function () {
      if ($(".licensing").length && $(".cky-consent-container").is(":visible")) {
        //console.log('cookie-law-info-bar');
        $("footer").css("padding-bottom", + $(".licensing").outerHeight() + $(".cky-consent-container").outerHeight() + 20);
      } else if ($(".licensing").length && $(".licensing").is(":visible")) {
        //console.log('licensing');
        $("footer").css("padding-bottom", + $(".licensing").outerHeight() + 20);
      }
    }).resize();

  }, 5000)

  // Scroll on samepage every where

  // $(".scroll-me").on('click', function(){
  //   var getScrollItem = $(this).data("scroll-class");
  //   gsap.to(window, {duration: 2, scrollTo: 400});
  //   return false;    
  // });


  // // Scroll to a given hash, preventing the event given if there is one
  // function scrollToHash(hash, e) {
  //   const elem = hash ? document.querySelector(hash) : false;
  //   if(elem) {
  //     if(e) e.preventDefault();
  //     gsap.to(window, {scrollTo: elem, offsetY: 50,  ease: "power2"});
  //   }
  // }

  // // If a link's href is within the current page, scroll to it instead
  // document.querySelectorAll('.scroll-me').forEach(a => {
  //   a.addEventListener('click', e => {
  //     e.preventDefault()
  //     var getHash = a.hash;
  //     console.log(getHash);
  //     gsap.to(window, {scrollTo: getHash  });
  //   });
  // });

  // // Scroll to the element in the URL's hash on load
  // scrollToHash(window.location.hash);


  document.querySelectorAll(".scroll-me").forEach((link, index) => {
    link.addEventListener("click", () => {
      var getHash = link.dataset.id;
      // var getHash = link.href.split('#')[1];
      // console.log(getHash);
      var getheaderHeight = document.querySelector("#header").clientHeight;
      //console.log(getheaderHeight);
      gsap.to(window, { duration: 1, scrollTo: { y: "#" + getHash, offsetY: getheaderHeight } });
    });
  });





})(jQuery, window, document);



